import { Static, Type } from '@sinclair/typebox';
import { PostPreviewSchema, PostSchema } from '../../posts-api/post/post.schema';
import { MinimalUser, minimalUserSchema } from '../user/user.schema';

export const reactionSchema = Type.Object({
  object: Type.Literal('Reaction'),
  value: Type.String({ description: 'Value of the reaction. Usually an emoji unicode.' }),
  sender: Type.Object(minimalUserSchema, { description: 'The user who sent the reaction.' }),
  is_sender: Type.Boolean({ description: 'Is the current user the sender of the reaction.' }),
});

export const ReactionWithParentPostSchema = Type.Composite([
  reactionSchema,
  Type.Object({ parent_post: Type.Union([PostPreviewSchema, PostSchema, Type.Null()]) }),
]);

export type Reaction<SenderSpecifics = unknown> = Omit<Static<typeof reactionSchema>, 'sender'> & {
  sender: MinimalUser<SenderSpecifics>;
};
export type ReactionWithParentPost<SenderSpecifics = unknown> = Omit<Static<typeof ReactionWithParentPostSchema>, 'sender'> & {
  sender: MinimalUser<SenderSpecifics>;
};
